export default [
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.pages.stepPassengers.name.common',
        skipIfUpsell: true,
    },
] as ProductFlowStep[];
